import _slicedToArray from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { __awaiter } from "tslib";
import React, { useState } from "react";
import { useSpring, config } from "react-spring";
import { generateKey } from "../../shared/utils";
import { colors } from "../../shared/constants";
import * as S from "./styles";
export var Tooltip = function Tooltip(_ref) {
  var o = _ref.children,
      t = _ref.position,
      e = _ref.arrow,
      i = _ref.content,
      a = _ref.className,
      r = _ref.tooltipBoxClass,
      _ref$animationSpeed = _ref.animationSpeed,
      l = _ref$animationSpeed === void 0 ? "normal" : _ref$animationSpeed,
      _ref$textColor = _ref.textColor,
      n = _ref$textColor === void 0 ? colors.white : _ref$textColor,
      _ref$color = _ref.color,
      s = _ref$color === void 0 ? colors.blue1 : _ref$color,
      _ref$uid = _ref.uid,
      c = _ref$uid === void 0 ? generateKey() : _ref$uid;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      p = _useState2[0],
      m = _useState2[1],
      d = "normal" === l ? config.default : "fast" === l ? config.stiff : config.slow,
      f = useSpring({
    to: function to(o) {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!p) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return o({
                  display: "block"
                });

              case 3:
                _context.next = 5;
                return o({
                  opacity: 1
                });

              case 5:
                _context.next = 11;
                break;

              case 7:
                _context.next = 9;
                return o({
                  opacity: 0
                });

              case 9:
                _context.next = 11;
                return o({
                  display: "none"
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    from: {
      opacity: 0,
      display: "none"
    },
    config: d
  });

  return React.createElement(S.TooltipContainer, {
    className: a,
    "data-testid": "tooltip-" + c
  }, React.createElement(S.TooltipChild, {
    position: t,
    id: "tooltip-icon-" + c,
    onClick: function onClick() {
      return m(!p);
    },
    onMouseEnter: function onMouseEnter() {
      return m(!0);
    },
    onMouseLeave: function onMouseLeave() {
      return m(!1);
    }
  }, o), React.createElement(S.TooltipBox, {
    color: s,
    arrow: e,
    position: t,
    style: f,
    id: "tooltip-box-" + c,
    className: r
  }, React.createElement(S.TooltipContent, {
    textColor: n
  }, i)));
};
export default Tooltip;